import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';
import { IStorageDeclarationMySuffix } from 'src/app/shared/model/storage-declaration-mysuffix.model';
import { StroageInsuranceFilterPagination } from 'src/app/shared/model/storage-insurance-filter-pagination.model';
import { createRequestOption } from 'src/app/shared/util/request-util';




@Injectable({ providedIn: 'root' })
export class StorageDeclarationMySuffixService {

    private declarationRequest = SERVER_API_URL + 'api/storage-declaration-request';
   

    constructor(private http: HttpClient) {}

    create(declaration: IStorageDeclarationMySuffix): Observable<HttpResponse<any>> {
        return this.http
            .post<any>(this.declarationRequest, declaration, { observe: 'response' });
    }
   
    findAllClient(url?: any): Observable<any> {
        return this.http.get<any>(SERVER_API_URL + url, { observe: 'response' }).map((res: any) => res);
    }

    findByIdAndUrl(id?:number,url?: any): Observable<any> {
        return this.http.get<any>(`${SERVER_API_URL}${url}/${id}` , { observe: 'response' }).map((res: any) => res);
    }

    findpackingTypeByCargoGroupAndStoragePolicy(storagePolicyId?:number,cargoGroupId?:number,locationId?:number,url?: any): Observable<any> {
        return this.http.get<any>(`${SERVER_API_URL}${url}/${storagePolicyId}/${cargoGroupId}/${locationId}` , { observe: 'response' }).map((res: any) => res);
    }
    findByUrl(url?: any): Observable<any> {
        return this.http.get<any>(`${SERVER_API_URL}${url}` , { observe: 'response' }).map((res: any) => res);
    }

    createByUrl(url:string, declaration: any): Observable<HttpResponse<any>> {
        return this.http
            .post<any>(`${SERVER_API_URL}${url}`, declaration, { observe: 'response' });
    }

    query(req?: any): Observable<HttpResponse<any[]>> {
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/storage-declaration-request';
        return this.http.get<any[]>(URL, { params: options, observe: 'response' });
    }

    myStorageInsuranceQuery(req?: any): Observable<HttpResponse<any[]>> {
        const options = createRequestOption(req);
        const URL =this.declarationRequest;
        return this.http.get<any[]>(URL, { params: options, observe: 'response' });
    }
    queryForStorageRuleInfo( storagePolicyId?:number,policyId?:number): Observable<HttpResponse<any[]>> {

        const URL = SERVER_API_URL + 'api/storage-rules/rule-declaration-info';
        return this.http.get<any[]>(`${URL}/${storagePolicyId}/${policyId}`, {  observe: 'response' });
    }

    queryForStorageRulePackingTypeMap( storagePolicyId?:number,policyId?:number): Observable<HttpResponse<Map<number, any[]>> >{

        const URL = SERVER_API_URL + 'api/storage-rules/packing-type-info';
        return this.http.get<Map<number, any[]>>(`${URL}/${storagePolicyId}/${policyId}`, {  observe: 'response' });
    }
    openStorageQuery(req?: any): Observable<HttpResponse<any[]>> {
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/open-storage-declaration-request';
        return this.http.get<any[]>(URL, { params: options, observe: 'response' });
    }
    post(url:string,data:any){
        return this.http.post<any>(`${SERVER_API_URL}${url}`, data, { observe: 'response' });
    }

    queryWithUrl(url?: any, req?: any): Observable<any> {
        const options = createRequestOption(req);
        const URL = this.declarationRequest + url;
        return this.http.get<any[]>(URL, { params: options, observe: 'response' });
    }
    put(url:string,data:any){
        return this.http.put<any>(`${SERVER_API_URL}${url}`, data, { observe: 'response' });
    }
   
    queryByLocationId(url:any,req?: any): Observable<HttpResponse<any[]>> {
        const options = createRequestOption(req);
        const URL = SERVER_API_URL + 'api/storage-declaration-request'+url;
        return this.http.get<any[]>(URL, { params: options, observe: 'response' });
    }

    queryByStoragePolicyId(id?: any, url?: string) :Observable<HttpResponse<any>> {
        // const options = createRequestOption(req);
        id = encodeURI(id);
        return this.http.get<any>(this.declarationRequest + url + '?storagePolicyId=' + id, { observe: 'response' });
    }


    queryAll(req?: StroageInsuranceFilterPagination): Observable<any> {
        // const options = createRequestOption(req);
        const URL =this.declarationRequest+'/storage-policy-id';
         return this.http.post<any[]>(URL, req, {  observe: 'response' });
     }
     
     queryBlobObject(url:string,id:any): Observable<HttpEvent<Blob>> {
        const _url = this.declarationRequest + url +'?storagePolicyId=' + id;
        return this.http.get(_url , { responseType: 'blob', observe: 'events' }).map(blob => {
            // window.open(_url);
            return blob;
        });
    }
    
    queryBlobObjectForExcel(url:string, id:any, data): Observable<HttpEvent<Blob>> {
        const _url = this.declarationRequest + url +'?storagePolicyId=' + id ;
        return this.http.post(_url, data , { responseType: 'blob', observe: 'events' }).map(blob => {
            // window.open(_url);
            return blob;
        });
    }
}
